import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "task-card-queue_list" }
const _hoisted_2 = ["textContent", "onClick"]

import { TaskModel, TaskQueueModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { PropType } from "vue";
import { TaskCardItemWrapper } from "./";
import { TirPmPopover, PopoverPositionEnum, PopoverColorEnum } from "tir-components";
import { useRouter } from "vue-router";
import { ListBulletIcon } from "tir-style-system/icons/outline";

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-queue',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;

const router = useRouter();

/**Параметры */


/**Перейти в очередь */
const goToQueue = (queue: TaskQueueModel) => {
  const projectId = Number(router.currentRoute.value.params.projectId);
  if (!queue.NamespaceId) {
    console.log("Нет id рабочей области");
  }
  const route = router.resolve({
    name: "queue",
    params: {
      projectId: projectId,
      namespaceId: queue.NamespaceId,
      queueId: queue.Id,
    },
  })?.href;

  window.open(route, "_target");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      (__props.task.Queues?.length)
        ? (_openBlock(), _createBlock(_unref(TirPmPopover), {
            key: 0,
            "is-tooltip": "",
            "is-no-teleport": "",
            color: _unref(PopoverColorEnum).Black,
            position: _unref(PopoverPositionEnum).Top,
            "is-hide-triangle": false,
            width: "15rem",
            class: "task-card-queue"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(ListBulletIcon), { class: "task-card-queue_icon" })
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.task.Queues, (queue) => {
                  return (_openBlock(), _createElementBlock("span", {
                    textContent: _toDisplayString(queue.Name),
                    class: "task-card-queue_list_item",
                    onClick: _withModifiers(($event: any) => (goToQueue(queue)), ["stop"])
                  }, null, 8, _hoisted_2))
                }), 256))
              ])
            ]),
            _: 1
          }, 8, ["color", "position"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})